import { DeliveryPerformanceAnalyticsActionTypes } from './constants';

type DeliveryPerformanceAnalyticsAction = { type: string, payload: {} | string };

export const deliveryPerformanceAnalyticsApiResponseSuccess = (actionType: string, data: any): DeliveryPerformanceAnalyticsAction => ({
    type: DeliveryPerformanceAnalyticsActionTypes.API_RESPONSE_SUCCESS,
    payload: { actionType, data },
});

export const deliveryPerformanceAnalyticsApiResponseError = (actionType: string, error: string): DeliveryPerformanceAnalyticsAction => ({
    type: DeliveryPerformanceAnalyticsActionTypes.API_RESPONSE_ERROR,
    payload: { actionType, error },
});

export const deliveryPerformanceAnalyticsGetOnTimeShipments = (query: string): DeliveryPerformanceAnalyticsAction => ({
    type: DeliveryPerformanceAnalyticsActionTypes.GET_ON_TIME_SHIPMENTS,
    payload: { query },
});

export const deliveryPerformanceAnalyticsGetLateShipments = (query: string): DeliveryPerformanceAnalyticsAction => ({
    type: DeliveryPerformanceAnalyticsActionTypes.GET_LATE_SHIPMENTS,
    payload: { query },
});

export const deliveryPerformanceAnalyticsGetEarlyShipments = (query: string): DeliveryPerformanceAnalyticsAction => ({
    type: DeliveryPerformanceAnalyticsActionTypes.GET_EARLY_SHIPMENTS,
    payload: { query },
});

export const deliveryPerformanceAnalyticsGetDeliveryPerformance = (query: string): DeliveryPerformanceAnalyticsAction => ({
    type: DeliveryPerformanceAnalyticsActionTypes.GET_DELIVERY_PERFORMANCE,
    payload: { query },
});

export const deliveryPerformanceAnalyticsGetDeliveryPerformanceByTimeframe = (query: string): DeliveryPerformanceAnalyticsAction => ({
    type: DeliveryPerformanceAnalyticsActionTypes.GET_DELIVERY_PERFORMANCE_BY_TIMEFRAME,
    payload: { query },
});
